var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contents" },
    [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "tab" },
          _vm._l(_vm.statusOptions, function (item, $index) {
            return _c(
              "span",
              {
                directives: [
                  {
                    name: "permissson",
                    rawName: "v-permissson",
                    value: `${item.permissson}`,
                    expression: "`${item.permissson}`",
                  },
                ],
                key: $index,
                class: ["tabItem", { active: _vm.activeName === item.value }],
                on: {
                  click: function ($event) {
                    return _vm.handleClick(item.value)
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(
                    item.value === 10000
                      ? `${item.label}(${_vm.tabTotal})`
                      : `${item.label}(${
                          _vm.tabNumer?.find((a) => a.type === +item.value)
                            ?.qty || 0
                        })`
                  )
                ),
              ]
            )
          }),
          0
        ),
        _c("div", { staticClass: "opt" }, [
          _c("div", { staticClass: "download", on: { click: _vm.download } }, [
            _vm._v("导出"),
          ]),
          _c(
            "div",
            { staticClass: "search" },
            [
              _c(
                "el-popover",
                {
                  ref: "popover",
                  staticClass: "searchPop",
                  attrs: {
                    placement: "top",
                    title: "批量搜索",
                    trigger: "click",
                    width: "378",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "close",
                      on: { click: _vm.closeSearchPanel },
                    },
                    [_c("i", { staticClass: "el-icon-close" })]
                  ),
                  _c("base-muti-input", {
                    ref: "baseMutiInput",
                    attrs: { default: _vm.referenceNumber },
                    model: {
                      value: _vm.referenceNumber,
                      callback: function ($$v) {
                        _vm.referenceNumber = $$v
                      },
                      expression: "referenceNumber",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        margin: "16px 0 0",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleEmpty },
                        },
                        [_vm._v("清空")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "sure",
                          on: { mousedown: _vm.handleConfirm },
                        },
                        [_vm._v("确定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-input", {
                staticClass: "input-search",
                attrs: {
                  value: _vm.searchVal,
                  placeholder: "请输入提单号搜索",
                },
                on: { focus: _vm.handleFocus },
              }),
              _c(
                "div",
                { staticClass: "btn-search", on: { click: _vm.handleConfirm } },
                [_c("i", { staticClass: "el-icon-search" })]
              ),
            ],
            1
          ),
          _vm.activeName === 0
            ? _c(
                "div",
                {
                  staticClass: "btn",
                  class: { "btn-active": !_vm.notUpdateFlag },
                  staticStyle: { "border-radius": "2px 0px 0px 2px" },
                  on: {
                    click: function ($event) {
                      return _vm.updateChange(false)
                    },
                  },
                },
                [_vm._v(" 已更新 ")]
              )
            : _vm._e(),
          _vm.activeName === 0
            ? _c(
                "div",
                {
                  staticClass: "btn",
                  class: { "btn-active": _vm.notUpdateFlag },
                  staticStyle: { "border-radius": "0px 2px 2px 0px" },
                  on: {
                    click: function ($event) {
                      return _vm.updateChange(true)
                    },
                  },
                },
                [_vm._v(" 未更新 ")]
              )
            : _vm._e(),
          _vm.filterList.date
            ? _c("div", { staticClass: "checkDate flex_c_c" }, [
                _vm._v(
                  " 查询时间：" +
                    _vm._s(
                      _vm.filterList.date[0] + "~" + _vm.filterList.date[1]
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "filter" },
            [
              _c(
                "base-filter",
                {
                  ref: "BaseFilter",
                  attrs: { width: 466, isActive: _vm.isActive },
                  on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
                },
                [
                  _c(
                    "div",
                    { staticClass: "filter" },
                    [
                      _c("SelectFilter", {
                        ref: "selectFilter",
                        attrs: {
                          filterListJson: _vm.filterListJson,
                          filterListId: _vm.filterListId,
                          companyDrapdown: _vm.companyDrapdown,
                        },
                        on: { ok: _vm.ok1 },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "data",
        },
        [
          _vm.height
            ? _c(
                "BaseTable",
                {
                  attrs: {
                    height: _vm.height,
                    tableData: {
                      ..._vm.tableData,
                      fileds: _vm.fileds,
                      columns: _vm.columns,
                    },
                    pageIndex: _vm.pager.pageIndex,
                    pageSize: _vm.pager.pageSize,
                    isPager: true,
                    isEmptyBorder: true,
                  },
                  on: {
                    handlePageChange: _vm.handlePageChange,
                    sortChange: _vm.sortChange,
                    dblclick: _vm.dblclick,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "holdDate",
                        fn: function (row) {
                          return [
                            _vm.isToday(row.scope.createdOn) &&
                            row.scope.createdName != "CBP"
                              ? _c("span", { staticClass: "tips" }, [
                                  _vm._v("NEW"),
                                ])
                              : _vm._e(),
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.scope.holdDate?.slice(
                                    0,
                                    row.scope.holdDate?.length - 3
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "createdOn",
                        fn: function (row) {
                          return [
                            _vm._v(" " + _vm._s(row.scope.createdOn) + " "),
                            row.scope.dischargeHarbor &&
                            row.scope.originHarborName !==
                              row.scope.dischargeHarbor
                              ? _c("span", { staticClass: "tips" }, [
                                  _vm._v(" 海铁联运 "),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "companyName",
                        fn: function (row) {
                          return [
                            _vm.activeName === 10000 || _vm.activeName === 3
                              ? [
                                  _vm._v(
                                    " " + _vm._s(row.scope.companyName) + " "
                                  ),
                                ]
                              : [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "top",
                                      style: {
                                        "background-color": row.scope.bgColor,
                                        "padding-left": row.scope.notUpdateFlag
                                          ? "0px"
                                          : "10px",
                                      },
                                    },
                                    [
                                      row.scope.notUpdateFlag
                                        ? _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/bill/waitUpdate.png"),
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        " " + _vm._s(row.scope.bgLabel) + " "
                                      ),
                                    ]
                                  ),
                                  _vm.activeName !== 10000 &&
                                  _vm.activeName !== 3
                                    ? _c("img", {
                                        staticClass: "editColor",
                                        attrs: {
                                          src: require("@/assets/images/bill/editColor.png"),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editColor(row.scope)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(
                                    " " + _vm._s(row.scope.companyName) + " "
                                  ),
                                ],
                          ]
                        },
                      },
                      {
                        key: "status",
                        fn: function (row) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "status",
                                class: _vm.status(row.scope.status),
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatStatus")(row.scope.status)
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "lastEventDescription",
                        fn: function (row) {
                          return [
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType0" },
                                [_vm._v("更新人")]
                              ),
                              _vm._v(_vm._s(row.scope.lastEventUserName) + " "),
                            ]),
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType1" },
                                [_vm._v("更新时间")]
                              ),
                              _vm._v(_vm._s(row.scope.lastEventDate) + " "),
                            ]),
                            _c(
                              "p",
                              {
                                staticStyle: {
                                  "text-align": "left",
                                  "max-width": "100%",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                  "white-space": "nowrap",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "pickUpType pickUpType2" },
                                  [_vm._v("内容")]
                                ),
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      row.scope.lastEventDescription
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "destroyQty",
                        fn: function (row) {
                          return [
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType0" },
                                [_vm._v("放行")]
                              ),
                              _vm._v(_vm._s(row.scope.releaseQty) + " "),
                            ]),
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType1" },
                                [_vm._v("扣件")]
                              ),
                              _vm._v(_vm._s(row.scope.holdQty) + " "),
                            ]),
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType2" },
                                [_vm._v("销毁")]
                              ),
                              _vm._v(_vm._s(row.scope.destroyQty) + " "),
                            ]),
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType3" },
                                [_vm._v("没收")]
                              ),
                              _vm._v(_vm._s(row.scope.confiscateQty) + " "),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "holdInfo",
                        fn: function (row) {
                          return [
                            row.scope.holdInfo.length > 0
                              ? _c("div", { staticClass: "checkInfo" }, [
                                  _c("div", [
                                    _c(
                                      "p",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pickUpType pickUpType1",
                                          },
                                          [_vm._v("查验日期")]
                                        ),
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatEearyDate")(
                                              row.scope.holdInfo
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "text-align": "left",
                                          "max-width": "100%",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pickUpType pickUpType2",
                                          },
                                          [_vm._v("查验类型")]
                                        ),
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatterInfo")(
                                              row.scope.holdInfo
                                            )
                                          ) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      { staticStyle: { "text-align": "left" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "pickUpType pickUpType3",
                                          },
                                          [_vm._v("查验原因")]
                                        ),
                                        _vm._v(
                                          _vm._s(
                                            row.scope.holdInfo[0].holdReason
                                          ) + " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "detail" },
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "bottom-end",
                                            width: "560",
                                            trigger: "click",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "detail-table" },
                                            [
                                              _c("BaseTable", {
                                                attrs: {
                                                  height: 240,
                                                  tableData: {
                                                    ..._vm.tableDeatil,
                                                    columns: row.scope.holdInfo,
                                                  },
                                                  isPager: false,
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "holdReason",
                                                      fn: function (detailRow) {
                                                        return [
                                                          _c("el-input", {
                                                            on: {
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.blur(
                                                                  detailRow,
                                                                  row.scope
                                                                    .holdInfo
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                detailRow.scope
                                                                  .holdReason,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    detailRow.scope,
                                                                    "holdReason",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "detailRow.scope.holdReason",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("img", {
                                            attrs: {
                                              slot: "reference",
                                              src: require("@/assets/images/bill/detail.png"),
                                            },
                                            slot: "reference",
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "inspectionSiteName",
                        fn: function (row) {
                          return [
                            _c("div", { staticClass: "checkInfo" }, [
                              _c("div", [
                                _c(
                                  "p",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "pickUpType pickUpType1" },
                                      [_vm._v("查验场")]
                                    ),
                                    _vm._v(
                                      _vm._s(row.scope.inspectionSiteName) + " "
                                    ),
                                    row.scope.inspectionSiteName
                                      ? _c("img", {
                                          staticClass: "link",
                                          attrs: {
                                            src: require("@/assets/images/bill/link.png"),
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.link(row.scope)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                                _c(
                                  "p",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "pickUpType pickUpType2" },
                                      [_vm._v("进查验场时间")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        row.scope.inspectionInTime?.split(
                                          " "
                                        )[0]
                                      ) + " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "p",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "pickUpType pickUpType3" },
                                      [_vm._v("出查验场时间")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        row.scope.inspectionOutTime?.split(
                                          " "
                                        )[0]
                                      ) + " "
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "detail",
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateCheckBoard(row.scope)
                                    },
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("@/assets/images/bill/editCheck.png"),
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "importerName",
                        fn: function (row) {
                          return [
                            _c("span", [
                              row.scope.isOwerCompany
                                ? _c("span", { staticClass: "importerName" }, [
                                    _vm._v(_vm._s(row.scope.isOwerCompany)),
                                  ])
                                : _vm._e(),
                              _vm._v(" " + _vm._s(row.scope.importerName)),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "holdResult",
                        fn: function (row) {
                          return [
                            _vm._v(" " + _vm._s(row.scope.holdResult) + " "),
                            _c(
                              "div",
                              {
                                staticClass: "detail",
                                on: {
                                  click: function ($event) {
                                    return _vm.updateHoldReason(row.scope)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/bill/editCheck.png"),
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "harborName",
                        fn: function (row) {
                          return [
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType0" },
                                [_vm._v("始发港/机场")]
                              ),
                              _vm._v(_vm._s(row.scope.originHarborName) + " "),
                            ]),
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType1" },
                                [_vm._v("卸货港")]
                              ),
                              _vm._v(_vm._s(row.scope.dischargeHarbor) + " "),
                            ]),
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType2" },
                                [_vm._v("目的港/机场")]
                              ),
                              _vm._v(
                                _vm._s(row.scope.destinationHarborName) + " "
                              ),
                            ]),
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType3" },
                                [_vm._v("船名/航次")]
                              ),
                              _vm._v(
                                _vm._s(row.scope.vesselName) +
                                  "/" +
                                  _vm._s(row.scope.voyageNo) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "ETDATD",
                        fn: function (row) {
                          return [
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType0" },
                                [_vm._v("ETD")]
                              ),
                              _vm._v(
                                _vm._s(_vm._f("dateFilete")(row.scope.etd)) +
                                  " "
                              ),
                            ]),
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType1" },
                                [_vm._v("ATD")]
                              ),
                              _vm._v(
                                _vm._s(_vm._f("dateFilete")(row.scope.atd)) +
                                  " "
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "ETAATA",
                        fn: function (row) {
                          return [
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType0" },
                                [_vm._v("ETA")]
                              ),
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateTimeFilter")(row.scope.eta)
                                ) + " "
                              ),
                            ]),
                            _c("p", { staticStyle: { "text-align": "left" } }, [
                              _c(
                                "span",
                                { staticClass: "pickUpType pickUpType1" },
                                [_vm._v("ATA")]
                              ),
                              _vm._v(
                                _vm._s(
                                  _vm._f("dateTimeFilter")(row.scope.ata)
                                ) + " "
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "opt",
                        fn: function (row) {
                          return [
                            _c(
                              "el-popover",
                              {
                                ref: `popover${row.scope.id}`,
                                attrs: {
                                  "popper-class": "pop-table-opt",
                                  width: "114",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c("div", { staticClass: "table-opt" }, [
                                  _vm.activeName === 0
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permissson",
                                                  rawName: "v-permissson",
                                                  value: "editStatus",
                                                  expression: "'editStatus'",
                                                },
                                              ],
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.modifyStatus(
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("更改状态")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permissson",
                                                  rawName: "v-permissson",
                                                  value: "billDetail",
                                                  expression: "'billDetail'",
                                                },
                                              ],
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.gotoBill(row.scope)
                                                },
                                              },
                                            },
                                            [_vm._v("提单详情")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.activeName === 1
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permissson",
                                                  rawName: "v-permissson",
                                                  value: "editStatus",
                                                  expression: "'editStatus'",
                                                },
                                              ],
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.modifyStatus(
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("更改状态")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.activeName === 2
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permissson",
                                                  rawName: "v-permissson",
                                                  value: "editStatus",
                                                  expression: "'editStatus'",
                                                },
                                              ],
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.modifyStatus(
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("更改状态")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.activeName === 3
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permissson",
                                                  rawName: "v-permissson",
                                                  value: "upload_file",
                                                  expression: "'upload_file'",
                                                },
                                              ],
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.uploadFile(
                                                    row.scope
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("上传费用凭证")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              directives: [
                                                {
                                                  name: "permissson",
                                                  rawName: "v-permissson",
                                                  value: "billDetail",
                                                  expression: "'billDetail'",
                                                },
                                              ],
                                              staticClass: "opt-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.gotoBill(row.scope)
                                                },
                                              },
                                            },
                                            [_vm._v("提单详情")]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _c("img", {
                                  staticStyle: { "margin-left": "-14px" },
                                  attrs: {
                                    slot: "reference",
                                    src: require("@/assets/images/table/opt.png"),
                                  },
                                  slot: "reference",
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    319726960
                  ),
                },
                [_vm._v('" ')]
              )
            : _vm._e(),
        ],
        1
      ),
      _c("UpdateCheckBoardDialog", {
        attrs: { rowData: _vm.rowData, dialogVisible: _vm.dialogVisible },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible = false
          },
        },
      }),
      _c("UpdateCheckBoardStatusDialog", {
        attrs: { rowData: _vm.rowData, dialogVisible: _vm.dialogVisible1 },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("UpdateCheckBoardColorDialog", {
        attrs: { rowData: _vm.rowData, dialogVisible: _vm.dialogVisible2 },
        on: {
          ok: _vm.ok,
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
      _vm.dialogVisible3
        ? _c("UploadFeeFileDialog", {
            attrs: { rowData: _vm.rowData, dialogVisible: _vm.dialogVisible3 },
            on: {
              ok: _vm.ok,
              cancel: function ($event) {
                _vm.dialogVisible3 = false
              },
            },
          })
        : _vm._e(),
      _c("follow-up-records-drawer", {
        attrs: {
          drawer: _vm.drawer,
          rowData: {
            ..._vm.rowData,
            id: _vm.rowData.mblId,
            status: 1,
          },
          showFinance: false,
          "bill-type": 2,
        },
        on: {
          close: function ($event) {
            _vm.drawer = false
          },
        },
      }),
      _c("DetailDrawer", {
        attrs: {
          drawer: _vm.drawer2,
          billType: _vm.billType,
          rowData: {
            ..._vm.rowData,
            id: _vm.rowData.mblId,
          },
        },
        on: {
          close: function ($event) {
            _vm.drawer2 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }